import React, { useContext } from 'react'
import { View, Text, ThemeContext } from '~/pagui'
import { WpComment } from './News'
import { css } from '@emotion/native'
import { css as hcss } from '@emotion/css'
import { LG_SIZE } from '~/pagui/components/View'

type Props = { comment: WpComment }
const readableDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
const blockText = hcss`
 p{
  font-family : Montserrat-Regular;
  line-height : 20px; 
  margin : 5px 0;
 }
`
const blockComment = css({
  backgroundColor: '#F5F5EB',
  
})

const sizeXL= css({
  width: '70%',
})
const sizeLG= css({
  width: '90%',
  margin : 'auto'
})

const fontCss = css({
  fontFamily: 'Montserrat-Regular',
})

const fontTitle = css({
  fontFamily: 'Matrice-SemiBold',
})
const CommentNode: React.FunctionComponent<Props> = ({ comment }) => {
  const [theme] = useContext(ThemeContext)

  return (
    <>
      <View
        minShowSize={LG_SIZE}
        style={[
          blockComment,
          sizeXL,
          theme.styles.p3,
          theme.styles.mt4,
          theme.styles.mb3,
        ]}
      >
        <Text style={[fontTitle]}>{comment.author.node.name}</Text>
        <div
          className={blockText}
          dangerouslySetInnerHTML={{ __html: comment.content }}
        />
        <Text style={[fontCss]}>{readableDate(comment.date)}</Text>
      </View>
      <View
        maxShowSize={LG_SIZE}
        style={[
          sizeLG,
          blockComment,
          theme.styles.p3,
          theme.styles.mt4,
          theme.styles.mb3,
        ]}
      >
        <Text style={[fontTitle]}>{comment.author.node.name}</Text>
        <div
          className={blockText}
          dangerouslySetInnerHTML={{ __html: comment.content }}
        />
        <Text style={[fontCss]}>{readableDate(comment.date)}</Text>
      </View>
    </>
  )
}

export default CommentNode
